const accentFold = (str: string): string =>
  typeof str === "string"
    ? str.normalize("NFD").replaceAll(/[\u0300-\u036F]/g, "")
    : "";

export default accentFold;
